import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChildProfile } from './appStateSlice';
import type { RootState } from '../store';

// Define a type for the slice state
interface SignupDataSlice {
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  phoneNumberCountryCode: string;
  phoneNumberNumber: string;
  childLevel: string;
}

// Define the initial state using that type
const initialState: SignupDataSlice = {
  username: '',
  password: '',
  firstname: '',
  lastname: '',
  phoneNumberCountryCode: '+852',
  phoneNumberNumber: '',
  childLevel: '',
};

export const signupDataSliceSlice = createSlice({
  name: 'signupData',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSignupData(
      state,
      action: PayloadAction<{ dataKey: keyof SignupDataSlice; data: string }>,
    ): void {
      state[action.payload.dataKey] = action.payload.data;
    },
  },
});

export const { setSignupData } = signupDataSliceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectSignupData = (state: RootState): SignupDataSlice => {
  return state.signupData;
};

export default signupDataSliceSlice.reducer;
